<template>
  <Modal :id="'cmp-booking-venues-add-venue'" @cancelled="onCancel">
    <template slot="header">{{$t('add_new_location')}}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'venuename'"
          required
          v-bind="textFieldConfig"
          v-model="venuename"
          isModel
          :placeholder="$t('location_name')"
          @valuechanged="onNameValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'city'"
          required
          v-bind="textFieldConfig"
          v-model="city"
          isModel
          :placeholder="$t('city')"
          @valuechanged="onCityValueChange"
        ></TextField>
        <Dropdown
          class="dt-dropdown m2"
          :options="countriesTV"
          :selected="country"
          :placeholder="$t('country')"
          v-on:selectedChange="e => onCountryChange(e)"
          box
        ></Dropdown>
      </div>
      <v-layout row wrap class="location-list-container">
        <table class="dt-table2 contact-table">
          <tbody class="dt-table2--body">
            <tr
              class="dt-table2--row"
              v-for="location in locations"
              :key="location.booking_location_id"
              @click.stop="event => onLocationClick(location)"
            >
              <td class="dt-table2--column">{{location['booking_location_name']}}</td>
              <td class="dt-table2--column">{{location['city']}}</td>
            </tr>
          </tbody>
        </table>
      </v-layout>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onAddVenue">{{$t('add_new_location')}}</button>
    </template>
  </Modal>
</template>

<script>
import { CountriesTV } from "../../../../models/country.model";
import { Subject } from "rxjs";
import { VenueService } from "../../services/venues";
import { createTextFieldConfig, EventHooks } from "../../../../plugins/text-field";
import { subscribeSubject } from "../../../../utility";
import { findCountryOfCity } from "../../../../dt-plugins/country";

import Modal from "@dtplugins/modal/modal";

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      venuename: "",
      city: "",
      country: null,

      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,

        valueChangedEvent: EventHooks.OnKeyup
      }),
      countriesTV: CountriesTV,

      searchSubject$: new Subject(),
      citySubject$: new Subject(),
      locations: []
      // Mark: Data
    };
  },
  mounted: function() {
    subscribeSubject(this, this.searchSubject$, searchString => {
      if (searchString.length > 1) {
        this.fetchList();
      }
    });
    subscribeSubject(this, this.citySubject$, searchString => {
      findCountryOfCity(this.city).then(res => {
        console.log(res);
        if (res) {
          this.country = res;
        }
      });
      if (searchString.length > 1) {
        this.fetchList();
      }
    });
  },
  watch: {},
  computed: {
    venue: function() {
      return {
        booking_location_name: this.venuename ? this.venuename : "",
        city: this.city ? this.city : "",
        country: this.country ? this.country.value : ""
      };
    }
  },
  methods: {
    onNameValueChange: function(name, value) {
      this.venuename = value;
      this.searchSubject$.next(value);
    },
    onCityValueChange: function(name, value) {
      this.city = value;
      this.citySubject$.next(value);
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onAddVenue: function() {
      this.$emit("added", this.venue);
    },
    onCountryChange: function(value) {
      this.country = value;
    },
    fetchList: function() {
      VenueService.searchLocation({
        location: this.venuename,
        city: this.city
      }).then(res => {
        this.locations = res.data.locations;
        console.log(this.locations);
      });
    },
    onLocationClick: function(location) {
      VenueService.linkLocation({
        booking_location_id: location.booking_location_id
      }).then(res => {
        console.log(res.data);
      });
      this.$emit("selected", location);
    }
    // Mark: Methods
  }
};
</script>

<style lang="scss">
.cmp-booking-venues-add-venue {
  .location-list-container {
    width: 100%;
    // height: 190px;
    // overflow: auto;

    table {
      margin-top: 10px;
      width: 100%;

      tbody {
        max-height: 190px;
        overflow: auto;
        min-height: 190px;

        tr {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
